<template>
  <x-accordian title="Organization type" :data-test-id="dataTestId">
    <v-row class="orgDataTables" slot="accordian_content" no-gutters>
      <table cellspacing="0" v-if="orgDetails">
        <tr>
          <th class="text-left">VAR Status</th>
          <th class="text-right">
            <label
              @click="openOverlay"
              v-if="canEditOrg()"
              class="editStyling"
              :data-test-id="`${dataTestId}__edit-btn`"
            >
              Edit
            </label>
          </th>
        </tr>
        <tr>
          <td colspan="2">{{ VARStatusList[orgDetails.varStatus] || '' }}</td>
        </tr>
      </table>

      <OverviewEditOrganisationType
        v-if="dialogState"
        :showDialog="dialogState"
        :orgDetails="orgDetails"
        @closeOverlay="closeOverlay"
      />
    </v-row>
  </x-accordian>
</template>
<script>
export default {
  name: 'org-type',
  data() {
    return {
      dialogState: false,
      VARStatusList: {
        NOT_A_VAR: 'Not a VAR',
        VAR_WHO_CAN_ADD_VARS: 'Can Add VARs',
        VAR_WHO_CANNOT_ADD_VARS: 'VAR Cannot Add VARs'
      },
      dataTestId: 'org-type-accordian'
    };
  },
  components: {
    OverviewEditOrganisationType: () =>
      import(
        '@/components/Organisations/dialogues/OverviewEditOrganisationTypeDialogue'
      )
  },
  methods: {
    openOverlay() {
      this.dialogState = true;
    },
    closeOverlay() {
      this.dialogState = false;
      this.$emit('updatePage');
    }
  },
  props: { orgDetails: Object, canEditOrg: Function }
};
</script>
